import { Component, Input, OnInit } from '@angular/core';
import { cpf } from 'cpf-cnpj-validator';
import { Credencial } from 'src/models/credencial.model';
import { WebSimulacao } from 'src/models/webSimulacao.model';
import { LoginService } from 'src/services/login.service';
import { WebSimulacaoService } from 'src/services/webSimulacao.service';
import validator from 'validator'
import { interval, Observable } from 'rxjs'
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { WebSimuladorAreaAberta } from 'src/models/WebSimuladorAberta.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent implements OnInit {
  cliente = environment.cliente;
  credencial: Credencial = new Credencial();
  simulacao: WebSimulacao = new WebSimulacao();
  WebSimuladorAreaAberta: WebSimuladorAreaAberta = new WebSimuladorAreaAberta();

  values = '';
  nome: string = '';
  interval: any
  timeOut: any = interval(3000)
  rentabilidade: number;
  idade: number;
  anos: number = 1;
  tab: number = 0;
  tempoRecebimento: number = 5;
  dataNascimento: Date;
  cpf: string = '';
  cpfValid: boolean = false;
  email: string = '';
  emailValid: boolean = false;

  checked1: number = 0;
  checked2: number = 2;
  checked3: number = 0;
  checked4: number = 0;
  valorSimulacao: number = 0;
  ctbSimulacao: number = 0;
  valorParcelado: number = 0;
  idSimulacao: number = 0;

  ok3: boolean = false;

  pergunta4_nao: number = null;
  pergunta4_sim: number = null;
  pergunta4_prece: number = 0; // Inicialize com um valor adequado


  pergunta5_sim: number = null;
  pergunta5_nao: boolean = false;

  pergunta7_sim: number = null;
  pergunta7_nao: boolean = false;

  finalContent: boolean = false;
  valorContribuicao: number = 0; // 🔹 valor unificado para o range

  valorMinimoContribuicao = 80;
  passoContribuicao = 10;
  considerarAbonoAnual: boolean = false;

  // Flags de validação
  dataNascimentoInvalida: boolean = false;
  idadeMaximaAtingida: boolean = false;
  idadeMinimaNaoAtingida: boolean = false;

  constructor(
    private readonly loginService: LoginService,
    private readonly webSimulacaoService: WebSimulacaoService
  ) { }


  ngOnInit() {
    this.credencial.login = "TRUSTWEB";
    this.credencial.senha = "TVARLBUTIB";
    this.loginService.autenticar(this.credencial).subscribe((obj) => {
      localStorage.setItem("token", obj.token);
    });
    // 🔥 AQUI: regra da rentabilidade
    if (this.cliente === 'PRECE') {
      this.rentabilidade = 8.70;
    } else {
      this.rentabilidade = 5;
    }

    this.valorContribuicao = this.cliente === 'PRECE'
      ? (this.pergunta4_prece || 80)
      : (this.pergunta4_nao || 80);

    // restante do seu ngOnInit...

  }

  iAnual(i) {
    return Math.pow((1 + (i / 100)), 1 / 12) - 1;
  }

  valorFuturo(vP, dM, i, n) {
    return vP * Math.pow((1 + i), n) + dM * (((Math.pow((1 + i), n)) - 1) / i);
  }

  valorPresente(vP, dM, i, n) {
    return vP / (((Math.pow((1 + i), n)) - 1) / i) + dM / (((Math.pow((1 + i), n)) - 1) / i);
  }

  calcularIdade() {
    if (!this.dataNascimento) {
      this.idade = null;
      this.dataNascimentoInvalida = false;
      this.idadeMaximaAtingida = false;
      return;
    }

    const dataNasc = new Date(this.dataNascimento);
    const hoje = new Date();

    // Verifica se a data é inválida
    if (!(dataNasc instanceof Date) || isNaN(dataNasc.getTime())) {
      this.idade = null;
      this.dataNascimentoInvalida = true;
      this.idadeMaximaAtingida = false;
      return;
    }

    // Verifica se a data é futura
    if (dataNasc > hoje) {
      this.idade = null;
      this.dataNascimentoInvalida = true;
      this.idadeMaximaAtingida = false;
      return;
    }

    // Calcula idade
    let idade = hoje.getFullYear() - dataNasc.getFullYear();
    const mesDiff = hoje.getMonth() - dataNasc.getMonth();
    const diaDiff = hoje.getDate() - dataNasc.getDate();

    if (mesDiff < 0 || (mesDiff === 0 && diaDiff < 0)) {
      idade--;
    }

    // Verifica idade máxima
    if (idade > 115) {
      this.idade = null;
      this.idadeMaximaAtingida = true;
      this.dataNascimentoInvalida = false;
      return;
    }

    // Se tudo ok (inclusive recém-nascido)
    this.idade = idade;
    this.dataNascimentoInvalida = false;
    this.idadeMaximaAtingida = false;
  }



  checarCPF() {
    this.cpfValid = cpf.isValid(this.cpf);
  }

  checarEmail() {
    this.emailValid = validator.isEmail(this.email);
  }


  isDataNascimentoValid() {
    return validator.isDate(this.dataNascimento.toString())
  }

  handleCheckClick(pergunta: number) {
    switch (pergunta) {
      case 5:
        this.pergunta5_nao = true;
        break;

      case 7:
        this.pergunta7_nao = true;
        break;
    }
  }

  formatMoney(n: number) {
    return n.toLocaleString('pt-br', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }).replace("R$", "");
  }

  handleSimular() {

if (this.cliente === 'PRECE') {

  const aporteMensal = this.pergunta4_prece ?? 0;
  const investimentoInicial = this.pergunta5_sim ?? 0;
  const anos = this.anos ?? 1;
  const tempoRecebimento = this.tempoRecebimento ?? 1;

  // Montante acumulado
  this.valorSimulacao = this.valorFuturo(
    investimentoInicial,
    aporteMensal,
    this.iAnual(this.rentabilidade),
    anos * 12
  );

  // Quantidade de pagamentos (12 ou 13)
  const quantidadePagamentos = this.getQuantidadePagamentos();

  // Renda mensal
  this.valorParcelado =
    this.valorSimulacao /
    (tempoRecebimento * quantidadePagamentos);
} else {

      switch (this.checked2) {
        case 1:
          this.pergunta5_sim = this.pergunta5_sim ? this.pergunta5_sim : 0;

          this.valorSimulacao = this.valorFuturo(
            this.pergunta5_sim,
            this.pergunta4_nao,
            this.iAnual(this.rentabilidade),
            this.anos * 12
          );

          this.valorParcelado = this.valorSimulacao / (this.tempoRecebimento * 13);
          break;

        case 2:
          this.valorParcelado = this.pergunta4_sim / (this.tempoRecebimento * 13);
          this.valorSimulacao = this.pergunta4_sim;

          this.ctbSimulacao = this.valorPresente(
            this.pergunta5_sim,
            this.valorSimulacao,
            this.iAnual(this.rentabilidade),
            this.anos * 12
          );
          break;
      }
    }

    if (this.interval) {
      this.interval.unsubscribe();
    }

    this.timeOut = interval(3000);
    this.interval = this.timeOut.subscribe(() => {
      this.salvarSimulacao();
    });
  }

  handleInput(event: any, pergunta: number) {
    switch (pergunta) {
      case 1:
        this.nome = event.target.value;
        break;

      case 2:
        this.idade = event.target.value;
        break;

      case 3:
        this.pergunta4_sim = event.target.value;
        break;

      case 4:
        this.pergunta4_nao = event.target.value;
        break;

      // 🟢 NOVO: captura o valor digitado em “Pergunta 4 PRECE”
      case 40: // identificador simbólico para a versão PRECE
        this.pergunta4_prece = event.target.value;
        break;

      case 5:
        this.pergunta5_sim = event.target.value;
        this.pergunta5_nao = false;
        break;

      case 7:
        this.pergunta7_sim = event.target.value;
        this.pergunta7_nao = false;
        break;
    }
  }


  next() {

    if (this.cliente === 'PRECE') {

      if (this.tab === 1 || this.tab === 2) {
        this.tab = 3;
      }
      else if (this.tab === 5) {
        this.tab = 7;
      }
      else {
        this.tab++;
      }

    } else {
      this.tab++;
    }

    if (this.tab >= 7) {
      document.body.style.height = "auto";
      document.body.style.overflowY = "scroll";
      this.handleSimular();
    }

  }

  back() {
    if (this.tab > 0) {
      if (this.cliente === 'PRECE') {
        // Pula a tab 2 e 6
        if (this.tab === 3) this.tab = 1;
        else if (this.tab === 6) this.tab = 5;
        else this.tab--;
      } else {
        this.tab--;
      }
    }
  }



  check1(value) {
    this.checked1 = value;
    this.ok3 = true;
  }

  check2(value) {
    this.checked2 = value;
    this.ok3 = true;
  }

  check3(value) {
    this.checked3 = value;
    this.ok3 = true;
  }

  check4(value) {
    this.checked4 = value;
    this.ok3 = true;
  }

  ProgressBar(value) {
    let bar = document.getElementById("myBar");
    bar.style.width = value + "%";

    if (value >= 20) {
      document.getElementById("circle1").style.backgroundColor = "#00497C";
    }

    if (value >= 50) {
      document.getElementById("circle2").style.backgroundColor = "#00497C";
    }

    if (value >= 90) {
      document.getElementById("circle3").style.backgroundColor = "#00497C";
    }
  }

  openFaleConosco(): void {
    window.open(environment.faleConoscoUrl, '_blank');
  }

salvarSimulacao() {

  // 🔹 Dados básicos
  this.WebSimuladorAreaAberta.nome = this.nome;
  this.WebSimuladorAreaAberta.email = this.email;
  this.WebSimuladorAreaAberta.cpf = this.cpf;
  this.WebSimuladorAreaAberta.dtNascimento = this.dataNascimento;

  // 🔹 Valores da simulação
  this.WebSimuladorAreaAberta.depositoInicial = this.pergunta5_sim ?? 0;
  this.WebSimuladorAreaAberta.tempoContribuicao = this.anos;
  this.WebSimuladorAreaAberta.tempoRecebimento = this.tempoRecebimento;
  this.WebSimuladorAreaAberta.rentabilidade = this.rentabilidade;
  this.WebSimuladorAreaAberta.valorSimulacao = this.valorSimulacao;
  this.WebSimuladorAreaAberta.valorDesejado = this.valorParcelado;

  // 🔹 Abono anual
  this.WebSimuladorAreaAberta.abonoAnual =
    this.considerarAbonoAnual ? 'Sim' : 'Não';

  // 🔹 Valor da contribuição
  if (this.cliente === 'PRECE') {

    this.WebSimuladorAreaAberta.valorContribuicao =
      this.pergunta4_prece ?? 0;

  } else {

    this.WebSimuladorAreaAberta.valorContribuicao =
      this.checked2 === 2
        ? (this.ctbSimulacao ?? 0)
        : (this.pergunta4_nao ?? 0);

  }

  // 🔹 Envia e-mail da simulação
  this.webSimulacaoService
    .EmailSimulacao(this.WebSimuladorAreaAberta)
    .subscribe(
      () => {
     //   console.log('Simulação enviada com sucesso');
      },
      (error) => {
        console.error('Erro ao enviar simulação', error);
      }
    );

  // 🔹 Finaliza intervalo
  if (this.interval) {
    this.interval.unsubscribe();
  }
}


  goToAdesao() {
    // window.open(`https://familia.previndus.com.br/adesao/#/ar/session/adesao?idSimulacao=${this.idSimulacao}`, "_blank");
    const url = `${environment.linkAdesao}`;
    window.open(url, "_blank");

  }

  novaSimulacao() {
    this.rentabilidade = this.cliente === 'PRECE' ? 8.70 : 5;
    //this.dataNascimento = null;
    this.email = '';
    this.cpf = '';
    //this.cpfValid = false;
    //this.emailValid = false;
    //this.idade = null;
    this.anos = 3;
    this.tempoRecebimento = 5;

    this.checked1 = 0;
    this.checked2 = 0;
    this.checked3 = 0;
    this.checked4 = 0;
    this.valorSimulacao = 0;
    this.ctbSimulacao = 0;
    this.valorParcelado = 0;

    this.ok3 = false;

    this.pergunta4_nao = null;
    this.pergunta4_sim = null;

    this.pergunta5_sim = null;
    this.pergunta5_nao = false;

    this.pergunta7_sim = null;
    this.pergunta7_nao = false;

    this.finalContent = false;

    // Voltar para a tela inicial
    this.tab = 0;

    // Rolar para o topo
    window.scroll(0, 0);
  }

  onRangeChange() {
    // 🔹 Impede valores abaixo do mínimo
    if (this.valorContribuicao < this.valorMinimoContribuicao) {
      this.valorContribuicao = this.valorMinimoContribuicao;
    }

    // 🔹 Arredonda o valor para o múltiplo de 10 mais próximo
    this.valorContribuicao =
      Math.round(this.valorContribuicao / this.passoContribuicao) * this.passoContribuicao;

    // 🔹 Sincroniza com a variável correta de acordo com o cliente
    if (this.cliente === 'PRECE') {
      this.pergunta4_prece = this.valorContribuicao;
    } else {
      this.pergunta4_nao = this.valorContribuicao;
    }

    // 🔹 Atualiza o cálculo da simulação em tempo real
    this.handleSimular();
  }
  isElegivelParaBeneficio(): boolean {

    if (!this.anos) return false;

    // Se for cliente PRECE, não exige idade mínima
    if (this.cliente === 'PRECE') {
      const tempoMinimoContribuicao = 1;
      return this.anos >= tempoMinimoContribuicao;
    }

    // Regra para os outros clientes
    if (!this.idade) return false;

    const idadeMinima = 18;
    const tempoMinimoContribuicao = 1;

    const idadeComContribuicao = this.idade + this.anos;

    return this.anos >= tempoMinimoContribuicao && idadeComContribuicao >= idadeMinima;
  }
  // Exemplo de ajuste automático no change
  onChangeContribuicao(valor: number) {
    if (valor < this.valorMinimoContribuicao) {
      this.pergunta4_prece = this.valorMinimoContribuicao;
    } else {
      // Arredonda para o múltiplo de 10 mais próximo
      this.pergunta4_prece = Math.round(valor / this.passoContribuicao) * this.passoContribuicao;
    }
  }
  getQuantidadePagamentos(): number {
    return this.considerarAbonoAnual ? 13 : 12;
  }

}
